<template>
  <van-popup v-model:show="model" class="!bg-light-grey p-3" position="bottom" @closed="onClose">
    <div class="flex items-center border-b pb-3 mb-3">
      <div class="flex-center relative">
        <niceone-image :src="$publicPath('/images/success-icon.png')" class="absolute" width="30"/>
        <van-circle
            :current-rate="currentRate"
            :rate="10"
            :speed="100"
            :stroke-width="40"
            size="40px"
        />
      </div>
      <div class="ms-3">
        <div class="font-niceone-medium text-base">{{ $t('product.may_like.item_added_to_shopping_cart') }}</div>
        <i18n-t keypath="product.may_like.cart_total" tag="div">
          <template #total>
            <span v-html="total"></span>
          </template>
        </i18n-t>
      </div>
    </div>
    <div class="font-niceone-medium text-lg mb-3">{{ $t('product.may_like.you_might_like_this_too') }}</div>
    <div ref="productsRef" class="flex relative overflow-x-auto mb-5">
      <product v-for="(product, index) in products" :key="`product-${index}`"
               :product="product" class="min-w-[160px] max-w-[160px] me-3"
               :source-data="setEventsData(product)"
               hide-tags>
        <template #image>
          <niceone-image :src="product.thumb" width="120"/>
        </template>
      </product>
    </div>
    <div class="flex gap-3 items-center w-full">
      <van-button block plain type="primary" @click="onClose">
        {{ $t('common.continue_shopping') }}
      </van-button>
      <van-button :to="$routerUrl('/cart')" block type="primary">
        {{ $t('common.finish_shopping') }}
      </van-button>
    </div>
  </van-popup>
</template>

<script setup>
import {useScroll} from '@vueuse/core'
import {EVENTS, EVENT_SOURCES} from "@/constants/events";

const currentRate = ref(100)
const model = ref(false)
const products = ref([])
const total = ref("")

const {on: onTriggeredLikeProducts} = useEventBus(EVENTS.LIKE_PRODUCTS)
onTriggeredLikeProducts(({products: cbProducts = [], total: cbTotal = ""}) => {
  products.value = cbProducts
  total.value = cbTotal
  model.value = true

  // Start the timer to increment the currentRate
  startProgressTimer();
});


const productsRef = ref(null)
const {isScrolling} = useScroll(productsRef)

let timer;
const startProgressTimer = () => {
  const totalDuration = 10000; // 10 seconds
  const updateInterval = 100; // Update every 100 milliseconds
  let remainingDuration = totalDuration;

  const decrementRate = () => {
    if (!isScrolling.value) {
      currentRate.value -= (updateInterval / totalDuration) * 100;
      remainingDuration -= updateInterval;

      // Stop the timer and close dialog when the progress is complete
      if (remainingDuration <= 0) {
        resetTimer()
        onClose()
      }
    }
  };

  // Update the currentRate every updateInterval milliseconds
  timer = setInterval(decrementRate, updateInterval);
};

const resetTimer = () => {
  clearInterval(timer);
}

const onClose = () => {
  resetTimer()
  timer = null;
  currentRate.value = 100;
  model.value = false;
  products.value = []
  total.value = ""
}

const setEventsData = (product) => {
  return {...EVENT_SOURCES.YOU_MAY_LIKE_SECTION, source_name: product?.en_name, source_id: product?.id}
}
</script>

<style scoped>

</style>